<script>
    export let id;
    export let title;
    export let status;
    export let username;
</script>

<details>
    <summary>
        <div class="{status}">
            {username} - {title}
        </div>
    </summary>
    <iframe title="{username} - {title}" style="border: 0; width: 100%; height: 42px;" src="https://bandcamp.com/EmbeddedPlayer/track={id}/size=small/bgcol=ffffff/linkcol=0687f5/transparent=true/" seamless></iframe>  
</details>

<style>
details {
    border: 1px solid #aaa;
    border-radius: 4px;
    padding: .5em .5em 0;
    margin: 10px;
    width: 100%;
    max-width: 500px;
}

summary {
    font-weight: bold;
    margin: -.5em -.5em 0;
    padding: .5em;
    text-align: left;
    text-overflow: ellipsis;
    display:flex;
    justify-content: start;
}

details[open] {
    padding: .5em;
}

details[open] summary {
    border-bottom: 1px solid #aaa;
    margin-bottom: .5em;
}
</style>